"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transactionalLoanPropertySchema = void 0;
exports.transactionalLoanPropertySchema = {
    type: 'object',
    required: [
        'cmhcAccountNumber',
        'additionalAddressStreetNumber',
        'appraisalTypeCode',
        'buildingConstructionYear',
        'buildingStoreyCount',
        'currentCmhcOfficeID',
        'previousCmhcOfficeID',
        'constructionMethodTypeCode',
        'dwellingTypeCode',
        'federalConstituencyID',
        'generatedPostalCodeIndicator',
        'housingFormCode',
        'housingStructureTypeCode',
        'liveableFloorAreaMeasurementCount',
        'marketAreaGeographicalTypeCode',
        'marketConditionTypeCode',
        'metropolitanMajorAreaID',
        'newExistingBuildingTypeCode',
        'projectName',
        'propertyAddressMunicipalityName',
        'propertyAddressPostalCode',
        'propertyAddressStreetDirectionID',
        'propertyAddressStreetNumber',
        'propertyAddressStreetName',
        'propertyAddressStreetTypeID',
        'propertyAddressUnitNumber',
        'propertyAgeConditionTypeCode',
        'propertyIDNumber',
        'propertyImprovementIndicator',
        'propertyLocationLegalDescription',
        'propertyLocationTypeCode',
        'propertyTaxAmount',
        'standardGeographicalLocationID',
        'streetNameKey',
        'tenureTypeCode',
        'totalBedCount',
        'totalBedroomCount',
        'totalUnitCount',
        'urbanRuralID',
        'recordCreatedTimestamp',
        'recordUpdatedTimestamp',
        'recordUpdatedUserID',
    ],
    properties: {
        cmhcAccountNumber: {
            type: 'integer',
            minimum: 0,
            maximum: 2147483648,
            errorMessage: 'should be an integer between 0 and 2147483648',
        },
        additionalAddressStreetNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 30,
            errorMessage: 'should have variable length up to 30 characters',
        },
        appraisalTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        addressID: {
            type: ['string', 'null'],
            errorMessage: 'should be string or null',
        },
        buildingConstructionYear: {
            type: 'integer',
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767',
        },
        buildingStoreyCount: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        currentCmhcOfficeID: {
            type: 'string',
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        previousCmhcOfficeID: {
            type: 'string',
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        code1RegistrationID: {
            type: ['integer', 'null'],
            minimum: -2147483648,
            maximum: 2147483648,
            errorMessage: 'should be an integer between 0 and 2147483648 or null',
        },
        constructionMethodTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        constructionStartDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        dwellingTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        effectiveBuildingAgeYearCount: {
            type: ['integer', 'null'],
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767 or null',
        },
        federalConstituencyID: {
            type: 'string',
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        geoID: {
            type: ['string', 'null'],
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000 or null',
        },
        generatedPostalCodeIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        housingFormCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        housingStructureTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        liveableFloorAreaMeasurementCount: {
            type: 'number',
            maximum: 99999,
            minimum: 0,
            errorMessage: 'should be a number with up to 5 digits in total',
        },
        marketAreaGeographicalTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        marketConditionTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        metropolitanMajorAreaID: {
            type: 'string',
            minLength: 0,
            maxLength: 4,
            errorMessage: 'should have maximum length of 4 characters',
        },
        newExistingBuildingTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        projectName: {
            type: 'string',
            minLength: 0,
            maxLength: 50,
            errorMessage: 'should have variable length up to 50 characters',
        },
        propertyAddressMunicipalityName: {
            type: 'string',
            minLength: 0,
            maxLength: 20,
            errorMessage: 'should have variable length up to 20 characters',
        },
        propertyAddressPostalCode: {
            type: 'string',
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should have maximum length of 6 characters',
        },
        propertyAddressStreetDirectionID: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        propertyAddressStreetNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 7,
            errorMessage: 'should have maximum length of 7 characters',
        },
        propertyAddressStreetName: {
            type: 'string',
            minLength: 0,
            maxLength: 30,
            errorMessage: 'should have variable length up to 30 characters',
        },
        propertyAddressStreetTypeID: {
            type: 'string',
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters',
        },
        propertyAddressUnitNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should have maximum length of 6 characters',
        },
        propertyAgeConditionTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        propertyIDNumber: {
            type: 'integer',
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767',
        },
        propertyImprovementIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        propertyLocationLegalDescription: {
            type: 'string',
            minLength: 0,
            maxLength: 60,
            errorMessage: 'should have variable length up to 60 characters',
        },
        propertyLocationTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        propertySaleAssessmentID: {
            type: ['integer', 'null'],
            minimum: 0,
            maximum: 2147483648,
            errorMessage: 'should be an integer between 0 and 2147483648 or null',
        },
        propertyTaxAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        remainingAmortizationEconomicLifeCount: {
            type: ['integer', 'null'],
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767 or null',
        },
        saleClosingDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        standardGeographicalLocationID: {
            type: 'string',
            minLength: 0,
            maxLength: 7,
            errorMessage: 'should have maximum length of 7 characters',
        },
        streetNameKey: {
            type: 'string',
            minLength: 0,
            maxLength: 10,
            errorMessage: 'should have maximum length of 10 characters',
        },
        tenureTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        totalBedCount: {
            type: 'number',
            maximum: 99999,
            minimum: 0,
            errorMessage: 'should be a number with up to 5 digits in total',
        },
        totalBedroomCount: {
            type: 'number',
            maximum: 99999,
            minimum: 0,
            errorMessage: 'should be a number with up to 5 digits in total',
        },
        totalUnitCount: {
            type: 'number',
            maximum: 99999,
            minimum: 0,
            errorMessage: 'should be a number with up to 5 digits in total',
        },
        unitRentDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        unitSaleDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        urbanRuralID: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        recordCreatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedUserID: {
            type: 'string',
            minLength: 0,
            maxLength: 8,
            errorMessage: 'should have maximum length of 8 characters',
        },
    },
};
